export default __webpack_public_path__ + "static/media/hair-dark-winter.e86ba94c.png";